export default "__VITE_ASSET__0j0ULTdL__"